import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../SectionTitle/SectionTitle";
import { getServices } from "../../api/service";
import "./ServiceSectionS3.scss";
import StarLoader from "../loader/StarLoader";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const ServiceSectionS3 = ({ home }) => {
  const [services, setServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 4;
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchServices = async () => {
      try {
        const data = await getServices();
        if (mounted) {
          setServices(data);
          setLoading(false); // stop loading immediately after fetch
        }
      } catch (error) {
        console.error("Error fetching services:", error);
        if (mounted) setLoading(false);
      }
    };

    fetchServices();

    return () => {
      mounted = false;
    };
  }, []);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }

  if (!services) return null;

  const totalPages = Math.ceil(services.length / perPage);

  // paginated services
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentServices = services.slice(indexOfFirst, indexOfLast);

  // handle page change
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  return (
    <section
      className="wpo-service-section-s4 section-padding"
      style={{
        backgroundColor: "#E6F7FF",
        paddingTop: "40px", // reduce vertical padding
        paddingBottom: "40px", // reduce vertical padding
      }}
    >
      <div className="container">
        <SectionTitle subTitle={"Our Services"} Title={"What We Do?"} />
        <div
          className="row"
          style={{ display: "flex", flexWrap: "wrap", alignItems: "stretch" }}
        >
          {home
            ? services.slice(0, 4).map((service, srv) => (
                <div
                  className="col-lg-6 col-md-12 col-12"
                  style={{ display: "flex" }}
                  key={srv}
                >
                  <div className="wpo-service-item" style={{ flex: 1 }}>
                    <div className="wpo-service-text">
                      <div
                        className="service-icon"
                        style={{
                          position: "relative",
                          width: "80px",
                          height: "80px",
                        }}
                      >
                        <i className={`fi ${service.icon}`}></i>
                        <img
                          src={`${apiUrl}/storage/` + service.banner}
                          alt=""
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div className="service-content">
                        <h2>{service.serviceName}</h2>

                        <Link
                          onClick={ClickHandler}
                          to={{
                            pathname: `/service-single/${service.id}`,
                            state: { allServices: services },
                          }}
                        >
                          Details
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : currentServices.map((service, srv) => (
                <div
                  className="col-lg-6 col-md-12 col-12"
                  style={{ display: "flex" }}
                  key={srv}
                >
                  <div className="wpo-service-item" style={{ flex: 1 }}>
                    <div className="wpo-service-text">
                      <div
                        className="service-icon"
                        style={{
                          position: "relative",
                          width: "80px",
                          height: "80px",
                        }}
                      >
                        <i className={`fi ${service.icon}`}></i>
                        <img
                          src={`${apiUrl}/storage/` + service.banner}
                          alt=""
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div className="service-content">
                        <h2>{service.serviceName}</h2>
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              service.description.slice(0, 100) +
                              (service.description.length > 100 ? "..." : ""),
                          }}
                        />
                        <Link
                          onClick={ClickHandler}
                          to={{
                            pathname: `/service-single/${service.id}`,
                            state: { allServices: services },
                          }}
                        >
                          Details
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
        </div>

        {/* pagination (only show when not home and more than 6 services) */}
        {!home && totalPages > 1 && (
          <div className="pagination-wrapper pagination-wrapper-center">
            <ul className="pg-pagination">
              {/* Prev */}
              <li className={currentPage === 1 ? "disabled" : ""}>
                <button
                  onClick={() =>
                    currentPage > 1 && handlePageChange(currentPage - 1)
                  }
                  aria-label="Previous"
                  disabled={currentPage === 1}
                >
                  <i className="ti-angle-left"></i>
                </button>
              </li>

              {/* Page Numbers */}
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i + 1}
                  className={currentPage === i + 1 ? "active" : ""}
                >
                  <button onClick={() => handlePageChange(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}

              {/* Next */}
              <li className={currentPage === totalPages ? "disabled" : ""}>
                <button
                  onClick={() =>
                    currentPage < totalPages &&
                    handlePageChange(currentPage + 1)
                  }
                  aria-label="Next"
                  disabled={currentPage === totalPages}
                >
                  <i className="ti-angle-right"></i>
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </section>
  );
};

export default ServiceSectionS3;
